function initRichRadio(selector, intialValue, callbackFunction, readOnly) {
	// eslint-disable-line no-unused-vars
	var selectedValue = null;
	var element = $(selector);

	selectValue(intialValue); // eslint-disable-line no-use-before-define

	if (!readOnly) {
		element.find('li').click(selectClicked); // eslint-disable-line no-use-before-define
	} else {
		element.find('li').css('cursor', 'default');
	}

	function selectClicked() {
		var clickedValue = $(this).attr('data-value');
		selectValue(clickedValue); // eslint-disable-line no-use-before-define
	}

	function selectValue(newValue) {
		if (newValue) {
			// clean UI selection
			if (selectedValue) {
				element.find('[data-value=' + selectedValue + ']').removeClass('is-selected');
			}

			if (selectedValue === newValue) {
				// clean value
				selectedValue = null;
			} else {
				// mark UI selection and store value
				selectedValue = newValue;
				element.find('[data-value=' + newValue + ']').addClass('is-selected');
			}

			callbackFunction && callbackFunction(selectedValue);
		}
	}
}